import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-typeform',
  templateUrl: './typeform.component.html',
  styleUrls: ['./typeform.component.scss']
})
export class TypeformComponent implements OnInit {
  flag: number;

  constructor() { }

  ngOnInit() {
  }

}
